module.exports = __webpack_public_path__ + "static/media/email.797d492c.svg";